

import BehaviorAction from './behavior_action';
import BehaviorFormElements from '../../constants/behavior_form_elements';
import BehaviorOperandFactory from '../expression/behavior_operand_factory';

import EnumValidator from 'validator/enum_validator';

export default class BehaviorSetPropertyAction extends BehaviorAction {
	_element;
	_fieldId;
	_gridId;
	_actionId;
	_property;
	_value;

	constructor(props = {}) {
		super(props);

		this._value = this._buildValue(props.value);
	}

	_buildValue(value) {
		return value && typeof value.type !== 'undefined' ? BehaviorOperandFactory.create(value) : {};
	}

	get element() {
		return this._element;
	}

	set element(value) {
		EnumValidator.validate(value, BehaviorFormElements);
		this._element = BehaviorFormElements[value];
	}

	get fieldId() {
		return this._fieldId;
	}

	set fieldId(value) {
		this._fieldId = value;
	}

	get gridId() {
		return this._gridId;
	}

	set gridId(value) {
		this._gridId = value;
	}

	get actionId() {
		return this._actionId;
	}

	set actionId(value) {
		this._actionId = value;
	}

	get property() {
		return this._property;
	}

	set property(value) {
		this._property = value;
	}

	get value() {
		return this._value;
	}

	set value(value) {
		this._value = this._buildValue(value);
	}
}
